<mat-card class="matched-mails">
  <mat-card-header>
    <div class="header-row">
      <span class="header-title">
        Matched Mails
        @if (unreadCount > 0) {
          <span class="unread-badge">{{ unreadCount }}</span>
        }
      </span>
      <div class="header-actions">
        @if (unreadCount > 0) {
          <button mat-icon-button matTooltip="Acknowledge all" (click)="acknowledgeAll()">
            <mat-icon>done_all</mat-icon>
          </button>
        }
        <button mat-icon-button matTooltip="Scan for missed mails" (click)="triggerMailSync()" [disabled]="isTriggeringSync">
          @if (isTriggeringSync) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <mat-icon>sync</mat-icon>
          }
        </button>
        <button mat-icon-button matTooltip="Refresh" (click)="loadMatchedMails()" [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    } @else if (matchedMails.length === 0) {
      <p class="no-mails">No matched mails found.</p>
    } @else {
      <div class="mail-list">
        @for (mail of matchedMails; track mail.message_id) {
          <div class="mail-item" [class.unread]="mail.mail_notification">
            <div class="mail-indicator">
              @if (mail.mail_notification) {
                <span class="dot"></span>
              }
            </div>
            <div class="mail-content">
              <div class="mail-subject">{{ mail.subject }}</div>
              <div class="mail-meta">
                <span class="mail-sender">{{ mail.sender_address }}</span>
                <span class="mail-date">{{ mail.received_at | date:'dd.MM.yyyy HH:mm' }}</span>
              </div>
            </div>
            <div class="mail-actions">
              @if (mail.mail_notification) {
                <button mat-icon-button matTooltip="Acknowledge" (click)="acknowledgeMail(mail)">
                  <mat-icon>check</mat-icon>
                </button>
              } @else {
                <mat-icon class="acknowledged-icon" matTooltip="Acknowledged">check_circle</mat-icon>
              }
            </div>
          </div>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
